import axios from "axios";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import AuthService from "../services/auth.service";

const instance = axios.create({
  baseURL: `/api`,
  headers: {
    "Content-Type": "application/json",
    withCredentials: true,
  },
});

instance.interceptors.request.use(
  (config) => {
    if (!config.headers["X-CSRF-TOKEN"]) {
      config.headers["X-CSRF-TOKEN"] = Cookies.get("csrf_access_token");
    }
    if (config.url === "auth/refresh-token") {
      config.headers["X-CSRF-TOKEN"] = Cookies.get("csrf_refresh_token");
    }
    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (res) => res,
  async (error) => {
    const prevRequest = error?.config;
    // console.log("axiosInstance", error.response, error.config);
    if (prevRequest.url !== "auth/login") {
      // Access Token was expired
      // console.log("Access Token Expired", prevRequest.url, prevRequest?.sent);
      // if (error?.response?.status === 401 && !prevRequest?.sent) {
      //   prevRequest.sent = true;
      //   try {
      //     const response = await AuthService.refreshToken();
      //     return instance(prevRequest);
      //   } catch (error) {
      //     console.log("Refresh fail");
      //     AuthService.logout();
      //   }
      // }
    }
    return Promise.reject(error);
  }
);

export default instance;
